import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    id: "olap-delete-versions-dialog",
    class: "p-fluid kn-dialog--toolbar--primary",
    style: _ctx.olapDeleteVersionsDialogDescriptor.style.dialog,
    visible: _ctx.visible,
    modal: true,
    closable: false
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-0 p-col-12" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.olap.deleteVersion.title')), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--secondary",
        onClick: _ctx.close
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.close')), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _ctx.deleteVersions
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.delete')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_ProgressBar, {
            key: 0,
            mode: "indeterminate",
            class: "kn-progress-bar"
          }))
        : _createCommentVNode("", true),
      (!_ctx.loading)
        ? (_openBlock(), _createBlock(_component_DataTable, {
            key: 1,
            class: "p-datatable-sm kn-table p-m-4",
            selection: _ctx.selectedVersions,
            "onUpdate:selection": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedVersions = $event)),
            value: _ctx.versions,
            dataKey: "id"
          }, {
            empty: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                selectionMode: "multiple",
                headerStyle: _ctx.olapDeleteVersionsDialogDescriptor.selectColumnStyle
              }, null, 8, ["headerStyle"]),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.olapDeleteVersionsDialogDescriptor.columns, (column) => {
                return (_openBlock(), _createBlock(_component_Column, {
                  key: column.header,
                  header: _ctx.$t(column.header),
                  field: column.field,
                  style: column.style,
                  sortable: true
                }, null, 8, ["header", "field", "style"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["selection", "value"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["style", "visible"]))
}